import { GetRolesResponse, newGetFunction } from "@src/service"
import { Uuid } from '@shared/helpers'
import { AddressTokensProps, supportedProtocolsUrl, EntityUrlProps, entityWalletsUrl, entityWalletUrl, ensUrl } from "./urls"

export const getWalletAddresses = newGetFunction<EntityUrlProps, {}>(entityWalletsUrl)
export const getWalletAddress = newGetFunction<EntityUrlProps & { address: Uuid }, {}>(entityWalletUrl)
export const getSupportedProtocols = newGetFunction<AddressTokensProps, {}>(supportedProtocolsUrl, true)
export const getENS = newGetFunction<AddressTokensProps, {}>(ensUrl, true)
